import React from "react";
import { css } from "@emotion/react";
import { Input } from "baseui/input";
import { BiSearchAlt2 } from "react-icons/bi";
import theme from "@styles/theme";

export interface SearchInputProps {
  onChange: (value: string) => void;
  value: string;
  placeholder: string;
  label?: string;
  containerStyle?: React.CSSProperties;
}

const SearchInput: React.FC<SearchInputProps> = ({
  onChange,
  value,
  placeholder,
  label,
  containerStyle,
}) => {
  return (
    <>
      {label && <label css={styles.label}>{label}</label>}
      <Input
        data-baseweb="search-input"
        startEnhancer={<BiSearchAlt2 />}
        onChange={(event) => onChange(event.currentTarget.value)}
        value={value}
        placeholder={placeholder}
        overrides={{
          Root: {
            style: ({ $isFocused }) => {
              const borderColor = $isFocused ? theme.colors.primaryA : theme.colors.contentInverseSecondary;
              return {
                backgroundColor: theme.colors.white,
                borderTopWidth: "1px",
                borderRightWidth: "1px",
                borderBottomWidth: "1px",
                borderLeftWidth: "1px",
                borderTopStyle: "solid",
                borderRightStyle: "solid",
                borderBottomStyle: "solid",
                borderLeftStyle: "solid",
                borderTopColor: borderColor,
                borderRightColor: borderColor,
                borderBottomColor: borderColor,
                borderLeftColor: borderColor,
                outline: "none",
                boxShadow: "none",
                justifyContent: `${containerStyle?.justifyContent}`,
                alignSelf: `${containerStyle?.alignSelf}`,
                width: `${containerStyle?.width}`,
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                borderBottomLeftRadius: "4px",
                borderBottomRightRadius: "4px",
                paddingTop: "1px",
                paddingRight: "1px",
                paddingBottom: "1px",
                paddingLeft: "1px",
              };
            },
          },
          StartEnhancer: {
            style: () => ({
              backgroundColor: theme.colors.white,
              borderTopWidth: "0",
              borderRightWidth: "0",
              borderBottomWidth: "0",
              borderLeftWidth: "0",
              outline: "none",
              boxShadow: "none",
            }),
          },
          InputContainer: {
            style: () => ({
              borderTopWidth: "0",
              borderRightWidth: "0",
              borderBottomWidth: "0",
              borderLeftWidth: "0",
              outline: "none",
              boxShadow: "none",
              width: `${containerStyle?.width}`,
            }),
          },
          Input: {
            style: () => ({
              fontFamily: "SourceSansPro-Regular",
              paddingLeft: "0",
              backgroundColor: theme.colors.white,
              boxShadow: "none",
              borderTopWidth: "0",
              borderRightWidth: "0",
              borderBottomWidth: "0",
              borderLeftWidth: "0",
              width: `${containerStyle?.width}`,
            }),
          },
        }}
      />
    </>
  );
};

const styles = {
  label: css({
    display: "block",
    marginBottom: "2px",
  }),
};

export default SearchInput;
